import React from 'react';
import { usePrevious } from '../usePrevious';
import { safeParseJSON } from '../../utils';
export const isRootPreviewStateItem = (item) => {
    if ('selectors' in item && 'type' in item) {
        return false;
    }
    return true;
};
const updateElementPreviewState = (previewState, element, state) => {
    if (!element) {
        return;
    }
    const { preview } = element.dataset;
    // Has new state
    if (previewState) {
        element.dataset.preview = state || previewState;
    }
    // No new state & has previous state — clear this state
    else if (preview) {
        delete element.dataset.preview;
    }
};
export const updatePreviewState = (previewState, element, stateMapItem) => {
    if (!stateMapItem) {
        return updateElementPreviewState(previewState, element);
    }
    const items = Array.isArray(stateMapItem) ? stateMapItem : [stateMapItem];
    items.forEach(item => {
        if (isRootPreviewStateItem(item)) {
            updateElementPreviewState(item.state, element);
        }
        else {
            const { selectors, type, state } = item;
            const assignPreviewStateToSelector = (selector) => {
                const selectedElements = type === 'single'
                    ? [element.querySelector(selector)]
                    : Array.from(element.querySelectorAll(selector));
                selectedElements.forEach(selectedElement => selectedElement &&
                    updateElementPreviewState(previewState, selectedElement, state));
            };
            if (Array.isArray(selectors)) {
                selectors.forEach(assignPreviewStateToSelector);
            }
            else {
                assignPreviewStateToSelector(selectors);
            }
        }
    });
};
export const clearPreviewStates = (element, stateMapItem) => {
    updatePreviewState(null, element, stateMapItem);
};
export function usePreviewState(id, compPreviewState, stateMap) {
    const ref = React.useRef();
    const previewState = usePrevious(compPreviewState);
    React.useLayoutEffect(() => {
        if (!ref.current) {
            // Looking for the component (by compId) in current document or topmost document in case of iframe
            const element = document.getElementById(id) || top?.document.getElementById(id);
            ref.current = element;
        }
        if (previewState !== compPreviewState) {
            clearPreviewStates(ref.current, stateMap?.[previewState || '']);
        }
        updatePreviewState(compPreviewState, ref.current, stateMap?.[compPreviewState || '']);
    }, [compPreviewState, stateMap, previewState, id]);
}
export const getPanelPreviewStateMap = (compPreviewState, panelType) => {
    if (!compPreviewState) {
        return;
    }
    const previewStateMap = safeParseJSON(compPreviewState) ?? {};
    return previewStateMap[panelType];
};
export const getDesignPanelPreviewStateMap = (compPreviewState) => {
    return getPanelPreviewStateMap(compPreviewState, 'designPanel');
};
export const getPartToPreviewStateMap = (designPanelPreviewStateMap) => {
    const { selectedPartId, selectedStateId, hoveredStateId } = designPanelPreviewStateMap ?? {};
    if (!selectedPartId || !selectedStateId) {
        return {};
    }
    const stateToPreview = hoveredStateId ?? selectedStateId;
    return {
        [selectedPartId]: stateToPreview,
    };
};
//# sourceMappingURL=usePreviewState.js.map